import React, { useState } from "react";
import styled from "styled-components";
import { Top } from "./Top/Top";
import { Solutions } from "./Solutions/Solutions";
import { Reasons } from "./Reasons/Reasons";
import { Pricing } from "./Pricing/Pricing";
import { FullWidthSectionWithContent } from "../common/FullWidthSectionWithContent";
import { HowToStart } from "./HowToStart/HowToStart";
import { Footer } from "./Footer/Footer";

export const Home = () => {
  const [activeCrm, setActiveCrm] = useState("UseDesk");

  return (
    <>
      <HomeContainer>
        <Top activeCrm={activeCrm} setActiveCrm={setActiveCrm} />
        <Solutions activeCrm={activeCrm} />
        <HowToStart />
        <FullWidthSectionWithContent
          background={"linear-gradient(180deg, #fbfaff 0%, #d1c7f5 100%);"}
        >
          <Reasons />
          <Pricing />
        </FullWidthSectionWithContent>
        <Footer />
      </HomeContainer>
    </>
  );
};

const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
